import { GetAllTripsForAdminState } from './getAllTripsForAdmin.types'

const initialState: GetAllTripsForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
